import { appAccessHandler } from '@core/routes/middleware/accounts.middleware'
export const MInitMiddleware = function(router){
    router.beforeEach(appAccessHandler)
}